import { buildDocumentPath } from '@/utils/studio'

/** Path of the blog index; every blog page lives at or below it. */
export const BLOG_INDEX_PATH = buildDocumentPath({ type: 'blog' })

/** True for the blog index and everything under it (posts, archives, pagination, search). */
export function isBlogPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  return pathname === BLOG_INDEX_PATH || pathname.startsWith(`${BLOG_INDEX_PATH}/`)
}
